import React from 'react';
import CustomBarWidth from '../graphs/custom-bar-width-graph/CustomBarWidth';
import BarWidth from '../graphs/bar-width-graph/BarWidth';
import CrossHair from '../graphs/cross-hair-graph/CrossHair';
import StackBarChart from './StackBarChart';
import StandardBarColor from '@common-components/graphs/standard-bar-graph/StandardBarColor';
import StandardBarVolume from '@common-components/graphs/standard-bar-graph/StandardBarVolume';
import GroupedBarChart from '@common-components/graphs/group-bar-graph/GroupedBarChart';

const StatisticsSummary = ({supplierId, batchNum}) => {
    return (
      <React.Fragment>
      <StackBarChart supplierId={supplierId} batchNo={batchNum} />
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-3 mt-3 custom-graphs'>
          <div className='dx-card responsive-paddings'>
            {/* <StandardBarColor /> */}
            {/* <CustomBarWidth supplierId={supplierId} batchNo={batchNum} /> */}
            <BarWidth supplierId={supplierId} batchNo={batchNum} />
          </div>
          <div className='dx-card responsive-paddings'>
              <CrossHair supplierId={supplierId} batchNo={batchNum} />
          </div>
          <div className='dx-card responsive-paddings'>
            <StandardBarVolume supplierId={supplierId} batchNo={batchNum}/>
          </div>
          <div className='dx-card responsive-paddings'>
            <GroupedBarChart supplierId={supplierId} batchNo={batchNum} />
          </div>
          {/* <div className='dx-card responsive-paddings'>
            <StandardBarColor />
          </div>
          <div className='dx-card responsive-paddings'>
            <StandardBarVolume />
          </div> */}
        </div>
      </React.Fragment>
    );
  };
  
export default StatisticsSummary;
  
